import React from 'react'
import useSound from 'use-sound'

// @ts-ignore
import notification from '../static/notification.mp3'

interface Props {
  isSoundNotification: boolean
}

const CountUnreadMessagesContext = React.createContext({
  unreadMessages: 0,
  setUnreadMessages: undefined,
})

const CountUnreadMessagesProvider: React.FC<Props> = ({
  isSoundNotification,
  children,
}) => {
  const [unreadMessages, setUnreadMessages] = React.useState(0)
  const [play, { stop }] = useSound(notification)

  React.useEffect(() => {
    stop()
    if (unreadMessages && isSoundNotification) {
      play()
    }
  }, [unreadMessages])

  const value = React.useMemo(
    () => ({
      unreadMessages,
      setUnreadMessages,
    }),
    [unreadMessages],
  )

  return (
    <CountUnreadMessagesContext.Provider value={value}>
      {children}
    </CountUnreadMessagesContext.Provider>
  )
}

export { CountUnreadMessagesProvider, CountUnreadMessagesContext }
